import { Button, Flex, Box } from '@chakra-ui/react';
import { RefreshCcw01 } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components';

interface LoadMoreProps {
  pagination: { total: number };
  page: { number: number };
  paginationLimit: number;
  applyPage: (pageNumber: number) => void;
  isLoading: boolean;
}

export const LoadMore: React.FC<LoadMoreProps> = ({
  pagination,
  page,
  paginationLimit,
  applyPage,
  isLoading,
}) => {
  const currentPage = page?.number || 1;
  const totalItems = pagination?.total || 0;
  const isDisabled = totalItems <= currentPage * paginationLimit;
  const displayedItems = Math.min(currentPage * paginationLimit, totalItems);

  const handleLoadMore = () => {
    applyPage(currentPage + 1);
  };

  return (
    <Flex
      justifyContent="center"
      position="relative"
      width="100%"
      alignItems="center"
    >
      <Box>
        <Button
          variant="quaternary"
          leftIcon={<RefreshCcw01 size="1em" />}
          onClick={handleLoadMore}
          disabled={isDisabled || isLoading}
          isLoading={isLoading}
        >
          {isLoading ? 'Loading...' : 'Load more results'}
        </Button>
      </Box>

      <Box position="absolute" right={0}>
        <KText size="sm-medium">
          {displayedItems} out of {totalItems}
        </KText>
      </Box>
    </Flex>
  );
};
